<div class="modal-body">

    <div class="row flex">
        <!-- <div class="col-md-2"><img src="./assets/project529/logo_2.png" style="width:100%"></div> -->
        <div class="col-md-12 iso-header">{{ (jobcard.project529.status === 'Stolen' ?
            'bikeshop.modal.update_job_card.project_529.stolen_header' :
            'bikeshop.modal.update_job_card.project_529.not_registered_header' ) | translate }}</div>
    </div>

    <div *ngIf="jobcard.project529.status === 'Stolen'" class="messages">
        <div class="row margin-top-16">
            <div class="col-md-12">{{'bikeshop.modal.update_job_card.project_529.stolen_modal_message' | translate}}
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-12"><a href="{{jobcard.project529.url}}" target="_blank">{{jobcard.project529.url}}</a>
            </div>
        </div>
        <div class="row margin-top-16">
            <div class="col-md-12">{{'bikeshop.modal.update_job_card.project_529.stolen_modal_message_extra' | translate}}
            </div>
        </div>        
    </div>

    <div *ngIf="jobcard.project529.status === 'Not Registered'" class="messages">
        <div class="row margin-top-16">
            <div class="col-md-12"><div [innerHTML]="'bikeshop.modal.update_job_card.project_529.not_registered_modal_message' | translate"></div>
            </div>
        </div>    

        <div class="row margin-top-8">
            <div class="col-md-4 label" [ngClass]="{'red': !emailValid()}">*{{'general.customer_email' | translate}}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [disabled]="emailLocked" [(ngModel)]="registerPayload.email"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label" [ngClass]="{'red': !registerPayload.serial_number || registerPayload.serial_number.length < 6}">*{{'bikeshop.modal.shared.bike.serial_no' | translate}}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [disabled]="serialNumberLocked" [(ngModel)]="registerPayload.serial_number"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">{{'bikeshop.modal.shared.bike.manufacturer' | translate}}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [(ngModel)]="registerPayload.manufacturer_string"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">{{'bikeshop.modal.shared.bike.model' | translate}}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [(ngModel)]="registerPayload.model_string"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">{{'bikeshop.modal.shared.bike.year' | translate}}:</div>
            <div class="col-md-8">
                <input type="number" pInputText [(ngModel)]="registerPayload.model_year"/>
            </div>
        </div>
        <!-- <div class="row margin-top-8">
            <div class="col-md-4 label">{{'general.headers.type' | translate}}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [(ngModel)]="registerPayload.bike_type"/>
            </div>
        </div>-->


        <div class="row margin-top-16">
            <div class="col-md-12">
                <div class="p-inputgroup">
                    <p-checkbox [(ngModel)]="consent" [binary]="true" inputId="binary"></p-checkbox>
                    <small style="margin-left: 8px;font-style: italic;">{{'bikeshop.modal.update_job_card.project_529.not_registered_modal_consent' | translate}}</small>
                  </div>
            </div>
        </div>   
    </div>

    <div class="row margin-top-16" *ngIf="errorRegistering">
        <div class="col-md-12 bold red" style="text-align: center;">
            {{ 'bikeshop.modal.update_job_card.project_529.registration_unsuccessful' | translate }}
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-3">
            <button class="iso-round-button full-width" [disabled]="busyRegistering" (click)="modal.dismiss('Cross click')">{{'general.close' | translate}}</button>
        </div>
        <div class="col-md-4">

        </div>
        <div class="col-md-5 flex" *ngIf="jobcard.project529.status == 'Not Registered'">            
            <button *ngIf="!busyRegistering" class="iso-light iso-round-button full-width" [disabled]="busyRegistering" (click)="register()" [disabled]="!consent || !valid()">{{'bikeshop.modal.update_job_card.project_529.register_bike' | translate}}</button>
            <div *ngIf="busyRegistering">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                                       animationDuration=".5s">
                                    </p-progressSpinner>
            </div>
        </div>
    </div>
</div>